import axios from 'axios';

import appSettings from '../app-settings';

const API_URL = `${appSettings.baseUrl}/campaigns/updates`;

export const getUpdates = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

export const getUpdate = async (updateId) => {
  const response = await axios.get(`${API_URL}/${encodeURIComponent(updateId)}`);
  return response.data;
};

export const createUpdate = async (data) => {
  const response = await axios.post(API_URL, data);
  return response.data;
};

export const getNewsSuggestions = async () => {
  const response = await axios.post(`${API_URL}/news-suggestions`);
  return response.data;
};
